/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StickyHeaderBaseComponent {
    @Input() dataCy?: string;
    @Input() disabled?: boolean;
    @Input() loading?: boolean;
}
